"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    root: {
      flexDirection: "row",
      position: "relative"
    },
    component: {
      display: "flex",
      padding: "0 4px",
      "&:first-child": {
        paddingLeft: 0
      },
      "&:last-child": {
        paddingRight: 0
      }
    },
    componentFullWidth: {
      flexBasis: "50%",
      maxWidth: "50%" // IE doesn't respect box-sizing for flex basis calculation, but it does for max-width

    },
    rangeLabel: {
      color: theme.palette.primary.main,
      display: "block",
      fontSize: ".75rem",
      fontWeight: "bold",
      position: "absolute",
      top: "-16px",
      // matches the padding provided by FormControl
      left: "4px" // match padding

    }
  };
};

exports.styles = styles;